import { MdErrorOutline } from "react-icons/md"
import { getColors, MobergIconSize, MobergTheme } from "../../../Moberg"
import React from "react"
import { useEnvironmentVariablesProvider } from "../../../Providers/EnvironmentVariablesProvider"

type MRNErrorProps = {
    message: string
}

export const MRNError: React.FC<MRNErrorProps> = ({ message }) => {
    const { environmentVariables } = useEnvironmentVariablesProvider()

    if (!message || !environmentVariables.FEATURE_FLAG_ADT_INTEGRATION) {
        return null
    }

    return (
        <MdErrorOutline 
            color={getColors(MobergTheme.RED).main} 
            size={MobergIconSize.SMALL} 
            title={message} 
        />
    )
}